import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { Actions, Getters, Mutations, TierState } from '@/interfaces/store/tier'
import { RootState } from '@/interfaces/store/root'
import Tier from '@/interfaces/tier'
import liff from '@line/liff'
import * as meService from '@/services/line-web-loyalty-bff/v1/me'

export const state: TierState = {
  tierLevelId: undefined,
  tierName: undefined,
  tierEffectiveDate: undefined,
  tierExpireDate: undefined,
  eligibleTier: undefined
}

export const getters: GetterTree<TierState, RootState> & Getters = {}
export const actions: ActionTree<TierState, RootState> & Actions = {
  async fetchTier({ commit }, payload: { token?: string }) {
    try {
      const { token } = payload
      if (!token) throw new Error('fetch tier token is missing')
      const result = await meService.getCustomerInfo(token, ['tier'], true)
      const statusCode = result.httpStatusCode
      if (statusCode === 200) {
        const { tier } = result.json.data
        commit('updateTier', tier as Tier)
      } else if (statusCode === 401) {
        console.warn('Unauthorized, redirecting to login')
        liff.logout()
        const currentUrl = new URL(window.location.href)
        const queryString = currentUrl.search
        const redirectUri = `${currentUrl.origin}${currentUrl.pathname}${queryString}`
        liff.login({ redirectUri })
      } else {
        throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
      }
    } catch (error) {
      console.log(error)
    }
  }
}

export const mutations: MutationTree<TierState> & Mutations = {
  updateTier(state: TierState, tier: Tier) {
    state.tierLevelId = tier?.tierLevelId
    state.tierName = tier?.tierName
    state.tierEffectiveDate = tier?.tierEffectiveDate
    state.tierExpireDate = tier?.tierExpireDate
    state.eligibleTier = tier?.eligibleTier
  }
}

export const store: Module<TierState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
